
import showToast from '../../utils/toast';
import { addEmployerService, getEmployerService, getSingleEmployerService, editEmployerService, deleteEmployerService, getEmployersAuditService, getSpecificEmployersAuditService, getSpecificEmployersAuditRevisionService, exportEmployerListService, assignEmployersToManagerService, markEmployerAsRefundAccountService, updateRefundAccountStatusService, removeAssignedManagerForEmployerService } from '../service/employerService';
import { startLoader, stopLoader } from './loaderActions';

export const ADD_EMPLOYER = 'ADD_EMPLOYER';
export const ADD_EMPLOYER_SUCCESS = 'ADD_EMPLOYER_SUCCESS';
export const ADD_EMPLOYER_FAILURE = 'ADD_EMPLOYER_FAILURE';

export const GET_EMPLOYERS = 'GET_EMPLOYERS';
export const GET_EMPLOYERS_SUCCESS = 'GET_EMPLOYERS_SUCCESS';
export const GET_EMPLOYERS_FAILURE = 'GET_EMPLOYERS_FAILURE';

export const SET_EMPLOYER_FILTERS = 'SET_EMPLOYER_FILTERS';

export const GET_EMPLOYERS_AUDIT = 'GET_EMPLOYERS_AUDIT';
export const GET_EMPLOYERS_AUDIT_SUCCESS = 'GET_EMPLOYERS_AUDIT_SUCCESS';
export const GET_EMPLOYERS_AUDIT_FAILURE = 'GET_EMPLOYERS_AUDIT_FAILURE';

export const GET_SPECIFIC_EMPLOYERS_AUDIT = 'GET_SPECIFIC_EMPLOYERS_AUDIT';
export const GET_SPECIFIC_EMPLOYERS_AUDIT_SUCCESS = 'GET_SPECIFIC_EMPLOYERS_AUDIT_SUCCESS';
export const GET_SPECIFIC_EMPLOYERS_AUDIT_FAILURE = 'GET_SPECIFIC_EMPLOYERS_AUDIT_FAILURE';
export const RESET_SPECIFIC_EMPLOYERS_AUDIT = 'RESET_SPECIFIC_EMPLOYERS_AUDIT';

export const GET_SINGLE_EMPLOYER = 'GET_SINGLE_EMPLOYER';
export const GET_SINGLE_EMPLOYER_SUCCESS = 'GET_SINGLE_EMPLOYER_SUCCESS';
export const GET_SINGLE_EMPLOYER_FAILURE = 'GET_SINGLE_EMPLOYER_FAILURE';

export const EDIT_EMPLOYER = 'EDIT_EMPLOYER';
export const EDIT_EMPLOYER_SUCCESS = 'EDIT_EMPLOYER_SUCCESS';
export const EDIT_EMPLOYER_FAILURE = 'EDIT_EMPLOYER_FAILURE';

export const RESET_ADDED_EMPLOYER_FLAG = 'RESET_ADDED_EMPLOYER_FLAG'
export const RESET_EDITED_EMPLOYER_FLAG = 'RESET_EDITED_EMPLOYER_FLAG'

export const DELETE_EMPLOYER = 'DELETE_EMPLOYER';
export const DELETE_EMPLOYER_SUCCESS = 'DELETE_EMPLOYER_SUCCESS';
export const DELETE_EMPLOYER_FAILURE = 'DELETE_EMPLOYER_FAILURE';

export const ASSIGN_EMPLOYERS_TO_MANAGER = 'ASSIGN_EMPLOYERS_TO_MANAGER';
export const ASSIGN_EMPLOYERS_TO_MANAGER_SUCCESS = 'ASSIGN_EMPLOYERS_TO_MANAGER_SUCCESS';
export const ASSIGN_EMPLOYERS_TO_MANAGER_FAILURE = 'ASSIGN_EMPLOYERS_TO_MANAGER_FAILURE';

export const REMOVE_MANAGER_FOR_EMPLOYER = 'REMOVE_MANAGER_FOR_EMPLOYER';
export const REMOVE_MANAGER_FOR_EMPLOYER_SUCCESS = 'REMOVE_MANAGER_FOR_EMPLOYER_SUCCESS';
export const REMOVE_MANAGER_FOR_EMPLOYER_FAILURE = 'REMOVE_MANAGER_FOR_EMPLOYER_FAILURE';

export const MARK_EMPLOYER_AS_REFUND = 'MARK_EMPLOYER_AS_REFUND';
export const MARK_EMPLOYER_AS_REFUND_SUCCESS = 'MARK_EMPLOYER_AS_REFUND_SUCCESS';
export const MARK_EMPLOYER_AS_REFUND_FAILURE = 'MARK_EMPLOYER_AS_REFUND_FAILURE';

export const UPDATE_REFUND_ACCOUNT_STATUS = 'UPDATE_REFUND_ACCOUNT_STATUS';
export const UPDATE_REFUND_ACCOUNT_STATUS_SUCCESS = 'UPDATE_REFUND_ACCOUNT_STATUS_SUCCESS';
export const UPDATE_REFUND_ACCOUNT_STATUS_FAILURE = 'UPDATE_REFUND_ACCOUNT_STATUS_FAILURE';

export const EXPORT_EMPLOYER_DATA = 'EXPORT_EMPLOYER_DATA';
export const EXPORT_EMPLOYER_DATA_SUCCESS = 'EXPORT_EMPLOYER_DATA_SUCCESS';
export const EXPORT_EMPLOYER_DATA_FAILURE = 'EXPORT_EMPLOYER_DATA_FAILURE';


export const addEmployer = () => ({
  type: ADD_EMPLOYER,
});

export const addEmployerSuccess = (response) => ({
  type: ADD_EMPLOYER_SUCCESS,
  payload: response,
});

export const addEmployerFailure = (error) => ({
  type: ADD_EMPLOYER_FAILURE,
  payload: error,
});

export const editEmployer = () => ({
  type: EDIT_EMPLOYER,
});

export const editEmployerSuccess = (response) => ({
  type: EDIT_EMPLOYER_SUCCESS,
  payload: response,
});

export const editEmployerFailure = (error) => ({
  type: EDIT_EMPLOYER_FAILURE,
  payload: error,
});

export const getEmployees = () => ({
  type: GET_EMPLOYERS,
});

export const getEmployeesSuccess = (response) => ({
  type: GET_EMPLOYERS_SUCCESS,
  payload: response,
});

export const getEmployeesFailure = (error) => ({
  type: GET_EMPLOYERS_FAILURE,
  payload: error,
});

export const setEmployerFilters = (response) => ({
  type: SET_EMPLOYER_FILTERS,
  payload: response,
});

export const getSpecificEmployersAudit = () => ({
  type: GET_SPECIFIC_EMPLOYERS_AUDIT,
});

export const getSpecificEmployersAuditSuccess = (response) => ({
  type: GET_SPECIFIC_EMPLOYERS_AUDIT_SUCCESS,
  payload: response,
});

export const getSpecificEmployersAuditFailure = (error) => ({
  type: GET_SPECIFIC_EMPLOYERS_AUDIT_FAILURE,
  payload: error,
});

export const resetSpecificEmployersAudit = () => ({
  type: RESET_SPECIFIC_EMPLOYERS_AUDIT,
});

export const getEmployersAudit = () => ({
  type: GET_EMPLOYERS_AUDIT,
});

export const getEmployersAuditSuccess = (response) => ({
  type: GET_EMPLOYERS_AUDIT_SUCCESS,
  payload: response,
});

export const getEmployersAuditFailure = (error) => ({
  type: GET_EMPLOYERS_AUDIT_FAILURE,
  payload: error,
});

export const addEmployers = () => ({
  type: ADD_EMPLOYER,
});

export const addEmployersSuccess = (response) => ({
  type: ADD_EMPLOYER_SUCCESS,
  payload: response,
});

export const addEmployersFailure = (error) => ({
  type: ADD_EMPLOYER_FAILURE,
  payload: error,
});


export const getSingleEmployer = () => ({
  type: GET_SINGLE_EMPLOYER,
});

export const getSingleEmployerSuccess = (response) => ({
  type: GET_SINGLE_EMPLOYER_SUCCESS,
  payload: response,
});

export const getSingleEmployerFailure = (error) => ({
  type: GET_SINGLE_EMPLOYER_FAILURE,
  payload: error,
});

export const deleteEmployer = () => ({
  type: DELETE_EMPLOYER,
});

export const deleteEmployerSuccess = (response) => ({
  type: DELETE_EMPLOYER_SUCCESS,
  payload: response,
});

export const deleteEmployerFailure = (error) => ({
  type: DELETE_EMPLOYER_FAILURE,
  payload: error,
});


export const resetEmployerAdded = () => ({
  type: RESET_ADDED_EMPLOYER_FLAG,
})

export const resetEmployerEdited = () => ({
  type: RESET_EDITED_EMPLOYER_FLAG,
})

export const assignEmployersToManager = () => ({
  type: ASSIGN_EMPLOYERS_TO_MANAGER,
});

export const assignEmployersToManagerSuccess = (response) => ({
  type: ASSIGN_EMPLOYERS_TO_MANAGER_SUCCESS,
  payload: response,
});

export const assignEmployersToManagerFailure = (error) => ({
  type: ASSIGN_EMPLOYERS_TO_MANAGER_FAILURE,
  payload: error,
});

export const removeManagerForEmployer = () => ({
  type: REMOVE_MANAGER_FOR_EMPLOYER,
});

export const removeManagerForEmployerSuccess = (response) => ({
  type: REMOVE_MANAGER_FOR_EMPLOYER_SUCCESS,
  payload: response,
});

export const removeManagerForEmployerFailure = (error) => ({
  type: REMOVE_MANAGER_FOR_EMPLOYER_FAILURE,
  payload: error,
});

export const markEmployerAsRefund = () => ({
  type: MARK_EMPLOYER_AS_REFUND,
});

export const markEmployerAsRefundSuccess = (response) => ({
  type: MARK_EMPLOYER_AS_REFUND_SUCCESS,
  payload: response,
});

export const markEmployerAsRefundFailure = (error) => ({
  type: MARK_EMPLOYER_AS_REFUND_FAILURE,
  payload: error,
});

export const updateRefundAccountStatus = () => ({
  type: UPDATE_REFUND_ACCOUNT_STATUS,
});

export const updateRefundAccountStatusSuccess = (response) => ({
  type: UPDATE_REFUND_ACCOUNT_STATUS_SUCCESS,
  payload: response,
});

export const updateRefundAccountStatusFailure = (error) => ({
  type: UPDATE_REFUND_ACCOUNT_STATUS_FAILURE,
  payload: error,
});

export const exportEmployerData = () => ({
  type: EXPORT_EMPLOYER_DATA,
});

export const exportEmployerDataSuccess = () => ({
  type: EXPORT_EMPLOYER_DATA_SUCCESS,
});

export const exportEmployerDataFailure = (error) => ({
  type: EXPORT_EMPLOYER_DATA_FAILURE,
  payload: error,
});

export const getEmployeesList = (payload) => async (dispatch) => {
  dispatch(getEmployees());
  dispatch(startLoader());

  try {
    const response = await getEmployerService(payload);

    if (response.success) {
      dispatch(getEmployeesSuccess(response));
    } else {
      dispatch(getEmployeesFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getEmployeesFailure('Error getting employee list'));
    showToast('Error getting employee list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getEmployersAuditList = (payload) => async (dispatch) => {
  dispatch(getEmployersAudit());
  dispatch(startLoader());

  try {
    const response = await getEmployersAuditService(payload);

    if (response.success) {
      dispatch(getEmployersAuditSuccess(response));
    } else {
      dispatch(getEmployersAuditFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getEmployersAuditFailure('Error getting employer audit list'));
    showToast('Error getting employer activity logs', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getSpecificEmployersAuditList = (payload) => async (dispatch) => {
  dispatch(getSpecificEmployersAudit());
  dispatch(startLoader());

  try {
    const response = await getSpecificEmployersAuditService(payload);

    if (response.success) {
      dispatch(getSpecificEmployersAuditSuccess(response));
    } else {
      dispatch(getSpecificEmployersAuditFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getSpecificEmployersAuditFailure('Error getting specific employer audit list'));
    showToast('Error getting employer activity logs', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

// TODO: as a temporary workaround used employer specific state for all types of audit details
export const getSpecificEmployersAuditRevisionList = (payload) => async (dispatch) => {
  dispatch(getSpecificEmployersAudit());
  dispatch(startLoader());

  try {
    const response = await getSpecificEmployersAuditRevisionService(payload);

    if (response.success) {
      dispatch(getSpecificEmployersAuditSuccess(response));
    } else {
      dispatch(getSpecificEmployersAuditFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getSpecificEmployersAuditFailure('Error getting specific employer audit list'));
    showToast('Error getting activity log details', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getSingleEmployerData = (employeeId) => async (dispatch) => {
  dispatch(getSingleEmployer());
  dispatch(startLoader());

  try {
    const response = await getSingleEmployerService(employeeId);

    if (response.success) {
      dispatch(getSingleEmployerSuccess(response));
    } else {
      dispatch(getSingleEmployerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getSingleEmployerFailure('Error getting single employee'));
    showToast('Error getting single employee', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const addEmployerData = (employeeData) => async (dispatch) => {
  dispatch(addEmployer());
  dispatch(startLoader());

  try {
    const response = await addEmployerService(employeeData);

    if (response.success) {
      dispatch(addEmployerSuccess(true));
      showToast(response.message, 'success');

    } else {
      dispatch(addEmployerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(addEmployerFailure('Error adding employee'));
    showToast('Error adding employee', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const editEmployerData = (employerId, employeeData) => async (dispatch, getState) => {
  dispatch(editEmployer());
  dispatch(startLoader());
  try {
    const response = await editEmployerService(employerId, employeeData);
    if (response.success) {
      dispatch(editEmployerSuccess(response.data));
      showToast(response.message, 'success');
    } else {
      dispatch(editEmployerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(addEmployerFailure('Error editing employee'));
    showToast('Error editing employee', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const deleteEmployerData = (employerId) => async (dispatch, getState) => {
  dispatch(deleteEmployer());
  dispatch(startLoader());
  try {
    const response = await deleteEmployerService(employerId);
    if (response.success) {
      dispatch(deleteEmployerSuccess(employerId));
      showToast(response.message, 'success');
    } else {
      dispatch(editEmployerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(addEmployerFailure('Error deleting employee'));
    showToast('Error deleting employee', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const assignEmployersToAccountManager = (payload) => async (dispatch) => {
  dispatch(assignEmployersToManager());
  dispatch(startLoader());

  try {
    const response = await assignEmployersToManagerService(payload);

    if (response.success) {
      dispatch(assignEmployersToManagerSuccess(payload));
      showToast(response.message, 'success');

    } else {
      dispatch(assignEmployersToManagerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(assignEmployersToManagerFailure('Error assigning employers'));
    showToast('Error assigning employers', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const removeAssignedManagerForEmployer = (employerId) => async (dispatch) => {
  dispatch(removeManagerForEmployer());
  dispatch(startLoader());

  try {
    const response = await removeAssignedManagerForEmployerService(employerId);

    if (response.success) {
      dispatch(removeManagerForEmployerSuccess(employerId));
      showToast(response.message, 'success');

    } else {
      dispatch(removeManagerForEmployerFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(removeManagerForEmployerFailure('Error removing assigned manager for employers'));
    showToast('Error removing assigned manager for employers', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const markEmployerAsRefundAccount = (employerId, payload) => async (dispatch) => {
  dispatch(markEmployerAsRefund());
  dispatch(startLoader());

  try {
    const response = await markEmployerAsRefundAccountService(employerId, payload);

    if (response.success) {
      let updateData = { ...payload, 'employerId': employerId };
      dispatch(markEmployerAsRefundSuccess(updateData));
      showToast(response.message, 'success');

    } else {
      dispatch(markEmployerAsRefundFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(markEmployerAsRefundFailure('Error marking as refund account'));
    showToast('Error marking as refund account', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const updateEmployerRefundAccountStatus = (employerId, payload) => async (dispatch) => {
  dispatch(updateRefundAccountStatus());
  dispatch(startLoader());

  try {
    const response = await updateRefundAccountStatusService(employerId, payload);

    if (response.success) {
      let updateData = { ...payload, 'employerId': employerId };
      dispatch(updateRefundAccountStatusSuccess(updateData));
      showToast(response.message, 'success');

    } else {
      dispatch(updateRefundAccountStatusFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(updateRefundAccountStatusFailure('Error updating refund status'));
    showToast('Error updating refund status', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const exportEmployerListInExcel = (payload) => async (dispatch) => {
  dispatch(exportEmployerData());
  dispatch(startLoader());
  try {
    const response = await exportEmployerListService(payload);
    if (response.success) {
      dispatch(exportEmployerDataSuccess());
      showToast(response.message, 'success');
    } else {
      dispatch(exportEmployerDataFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(exportEmployerDataFailure('Error exporting employer data'));
    showToast('Error exporting employer data', 'error');
  } finally {
    dispatch(stopLoader());
  }
};


export const clearAddedEmployerFlag = () => async (dispatch) => {
  dispatch(resetEmployerAdded(null));
}

export const clearEditedEmployerFlag = () => async (dispatch) => {
  dispatch(resetEmployerEdited(null));
}